<template>
    <div class="user-list">
        <el-form :inline="true" class="demo-form-inline" :loading="loading" size="mini">
            <el-form-item label="手机号">
                <el-input placeholder="手机号" v-model="filter.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="封号状态">
                <el-select v-model="filter.isDeleted">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已解封" :value="0"></el-option>
                    <el-option label="封禁中" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="处理状态">
                <el-select v-model="filter.applyStatus">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="label,key in map.user.applyStatus" :key="key" :label="label" :value="key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini">
            <el-table-column prop="userId" label="用户id"></el-table-column>
            <el-table-column label="用户昵称">
                <template slot-scope="scope"><a :href="`/user_item?id=${scope.row.userAesId}`" target="_blank">{{scope.row.nickname}}</a></template>
            </el-table-column>
            <el-table-column prop="phoneNumber" label="用户手机号"></el-table-column>
            <el-table-column prop="isDeleted" label="封号状态">
                <template slot-scope="scope">{{map.user.banStatus[scope.row.isDeleted]}}</template>
            </el-table-column>
            <el-table-column prop="status" label="处理状态">
                <template slot-scope="scope">{{map.user.applyStatus[scope.row.status]}}</template>
            </el-table-column>
            <el-table-column prop="banTime" label="封禁时间"></el-table-column>
            <el-table-column prop="createTime" label="申请时间"></el-table-column>
            <el-table-column prop="unblockTime" label="解封时间"></el-table-column>
            <el-table-column label="操作" width="280">
                <template slot-scope="scope">
                    <el-button-group size="mini">
                        <el-button type="success" :disabled="!scope.row.reason" size="mini" @click="showDetail(scope.row)">查看申请内容</el-button>
                        <el-button type="success" size="mini" :disabled="scope.row.status !== 0" @click="$router.push(`/user_item?id=${scope.row.userAesId}&applyId=${scope.row.id}`)">设置解封时间</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div>
            <el-pagination background layout="prev, pager, next" :page-size="limit" @current-change="i=>pageNum=i" :page-count="pageNum" :total="total">
            </el-pagination>
        </div>

        <el-dialog title="解封申请" :visible.sync="dialogShow" class="apply-detail">
            <dl>
                <dt>申请理由</dt>
                <dd><pre>{{curData.reason}}</pre></dd>
            </dl>
            <dl v-if="curData.annex && curData.annex.length">
                <dt>申请材料</dt>
                <dd>
                    <p v-for="file in curData.annex"><a :href="file.url" target="_blank">{{file.name}}</a></p>
                </dd>
            </dl>
        </el-dialog>

    </div>
</template>
<script>
import map from '../../datamap'
import api from '../api'
let {
    user
} = api
export default {
    name: 'bans',
    data() {
        return {
            map,
            loading: true,
            filter: {
                phoneNumber: '',
                isDeleted: '',
                applyStatus: '', // 处理状态（1：是 0：否）
            },
            list: [],
            total: 0,
            pageNum: 1,
            limit: 20,
            dialogShow: false,
            curData: {},
        }
    },
    watch: {
        pageNum() {
            this.fetch()
        }
    },
    methods: {
        async fetch(num) {
            if (num == 1) {
                this.pageNum = 1
            }
            let {
                phoneNumber,
                isDeleted,
                applyStatus,
            } = this.filter
            let res = await user.unBanApplies({
                pageNum: this.pageNum,
                limit: this.limit,
                phoneNumber,
                isDeleted,
                applyStatus,
            })
            this.list = res.data.data
            this.total = res.data.pageinfo.totalCount
        },
        showDetail(data) {
            this.curData = data;
            this.dialogShow = true;
        },
    },
    mounted() {
        this.fetch(1);
    }
}
</script>
<style>
.apply-detail dl dd pre {
    margin: 10px 0 0;
    word-break: break-all;
    white-space: pre-wrap;
    overflow-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/views/user/bans.vue